export const SHOW_MARGIN_IN_SPOOF_MODE_COOKIE_NAME = 'show_margin_in_spoof_mode'

export function setMarginInSpoofModeCookie(value: boolean) {
  document.cookie = `${SHOW_MARGIN_IN_SPOOF_MODE_COOKIE_NAME}=${(value ? 'on' : 'off')}; expires=Fri, 29 Dec 2028 23:59:59 GMT; path=/; domain=.${document.domain}`
}
